import i18n from 'i18n-js';
import { getLanguage } from './localeFormatting';
export const DEFAULT_FALLBACKS = false;
export const DEBUG = false; // this should be set to false so we don't log warning messages in PROD.
/* i18n Configuration */
i18n.fallbacks = DEFAULT_FALLBACKS;
//@ts-ignore
i18n.missingTranslation = (key) => {
    const message = `missing "${key}" translation for locale "${i18n.locale}"`;
    if (DEBUG) {
        console.warn(`[@sfdc-www/digital-18n]: ${message}`);
    }
    return `[${message}]`;
};
//@ts-ignore
i18n.missingPlaceholder = (placeholder, label) => {
    if (DEBUG) {
        console.warn(`[@sfdc-www/digital-18n]: missing "${placeholder}" placeholder in "${label}"`);
    }
    return `[missing ${placeholder} value]`;
};
let state = {
    configureHandlers: [],
    changeHandlers: [],
    i18n: [i18n],
    // This is arbitrarily high to avoid conflicting with old versions before the guids were unique
    previousId: 2000,
};
export class I18n {
    id = this.getUniqueId();
    fallbacks;
    constructor(scope) {
        if (scope)
            this.addScope(scope);
    }
    t(scope, key, options) {
        return i18n.t(`${scope}_${this.id}.${key}`, options);
    }
    addScope(scope) {
        for (const [scopeName, locales] of Object.entries(scope)) {
            for (const [locale, labels] of Object.entries(locales)) {
                const localeKey = getLanguage({ locale });
                i18n.translations[localeKey] = {
                    ...i18n.translations[localeKey],
                    [`${scopeName}_${this.id}`]: labels,
                };
            }
        }
    }
    getUniqueId() {
        return (state.previousId += 1);
    }
}
export function configure(configHandler) {
    state.configureHandlers.push(configHandler);
    for (const i18n of state.i18n) {
        configHandler(i18n);
    }
}
export function setLanguage(locale) {
    const selectedLanguage = getLanguage({ locale });
    configure((i18n) => {
        i18n.locale = selectedLanguage;
    });
    for (const handler of state.changeHandlers) {
        handler(selectedLanguage);
    }
}
export function getActiveLanguage(format) {
    //@ts-ignore
    return getLanguage({ locale: i18n.currentLocale(), format });
}
export function registerLocaleChangeHandler(handler) {
    state.changeHandlers.push(handler);
    return () => {
        state.changeHandlers = state.changeHandlers.filter((h) => h !== handler);
    };
}
export function localizeNumber(input) {
    const n = typeof input === 'string' ? parseFloat(input.replace(/,/, '')) : input;
    return n.toLocaleString(i18n.currentLocale());
}
export function localizeDate(input) {
    const n = new Date(input);
    return n.toLocaleDateString(i18n.currentLocale());
}
export function initializeState(currentState, existingState) {
    if (!existingState)
        return currentState;
    // Most likely, i18n is the same between modules as the i18n-js module attaches to window and then exports any
    // previously set instance. To ensure backwards compatibility, and to guard against changes to the i18n-js module in
    // the future, we keep the array of instances here.
    if (!existingState.i18n.includes(i18n)) {
        existingState.i18n = [...existingState.i18n, i18n];
    }
    // Run configurations that happened before this module was loaded
    for (const configHandler of existingState.configureHandlers) {
        configHandler(i18n);
    }
    // Ensure the previousId doesn't match between runs
    existingState.previousId += 1;
    return existingState;
}
// This module may be executed multiple times from different sources
if (typeof window !== 'undefined') {
    // @ts-ignore
    window['@sfdc-www/digital-i18n'] = state = initializeState(state, 
    // @ts-ignore
    window['@sfdc-www/digital-i18n']);
}
//# sourceMappingURL=i18n.js.map